import { z } from 'zod';

export const formSchema = z.object({
  phone: z.string().min(1, { message: 'Required' }),
  birthDate: z.date().min(new Date('1900-01-01'), { message: 'Invalid date' }),
  hometown: z.string(),
  address: z.string().min(1, { message: 'Required' }),
  city: z.string().min(1, { message: 'Required' }),
  stateCode: z.string().min(1, { message: 'Required' }),
  zipCode: z.string().min(1, { message: 'Required' }),
  regions: z
    .array(z.string())
    .min(1, { message: 'Must select at least 1 region' }),
  workExperience: z.string()
});
